import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CalendarDays } from "lucide-react";
import { api } from "../api";
import { useLang } from "../i18n";
import { StatusBadge, DemoRibbon } from "../components/StatusBadge";

export default function ConsultationsPage() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/consultations").then((r) => setItems(r.data.results)).catch(() => setItems([]));
  }, []);

  if (items === null) return <div className="p-20 text-center text-slate-500">{t("common.loading")}</div>;

  return (
    <div data-testid="consultations-page" className="mx-auto max-w-5xl px-4 py-10 sm:px-6">
      <div className="flex items-center gap-3">
        <h1 className="font-heading text-3xl font-extrabold tracking-tight sm:text-4xl">{t("cons.title")}</h1>
        <DemoRibbon label={t("demo.label")} />
      </div>
      <p className="mt-2 text-base text-slate-600">{t("cons.subtitle")}</p>

      <div className="mt-8 space-y-3">
        {items.map((c) => (
          <button
            key={c.id}
            data-testid={`consultation-row-${c.id}`}
            onClick={() => navigate(`/gmina/${c.gmina_id}`)}
            className="flex w-full flex-wrap items-center justify-between gap-3 rounded-xl border bg-white p-5 text-left transition-shadow hover:shadow-md"
          >
            <div>
              <p className="text-base font-semibold text-slate-900">{c.document_title}</p>
              <p className="mt-1 text-sm text-slate-500">{c.gmina_name}</p>
              <p className="mt-1 flex items-center gap-1.5 text-xs text-slate-500">
                <CalendarDays size={12} />
                {t("cons.start")}: {c.start_date} · {t("cons.deadline")}: <span className="font-bold text-slate-700">{c.end_date}</span>
              </p>
            </div>
            <StatusBadge status={c.status} label={t(`cons.${c.status}`)} testId={`consultation-badge-${c.id}`} />
          </button>
        ))}
      </div>
    </div>
  );
}
